export default __webpack_public_path__ + "static/media/Myob.c026c752.png";